import { useState, useEffect } from "react";
import { Modal, Box, Button, TextField, Grid } from "@mui/material";

// Supabase
import supabase from "../../supabaseClient";

// Components
import { useNotification } from "../utils/Notification";
import { trackEvent } from "../utils/Utils";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "60%" },
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  overflowY: "auto",
  p: 4,
};

export default function GeneralCondition({ open, onClose, file }) {
  const [fileName, setFileName] = useState("");
  const [fileDescription, setFileDescription] = useState("");

  // Components
  const { showNotification } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    if (file) {
      setFileName(file.name);
      setFileDescription(file.description);
    }
  }, [file]);

  const handleSubmit = async () => {
    trackEvent("file-form_submit");
    try {
      const sanitizedName = fileName.toUpperCase().replace(/[^A-Z0-9]/g, "");
      const { error } = await supabase
        .from("files")
        .update([
          {
            name: sanitizedName,
            description: fileDescription,
          },
        ])
        .eq("id", file.id);

      if (error) {
        throw error; // Throw the error to be caught in the catch block
      }

      showNotification(t("file.updatedSuccess"), "success");
      setFileName("");
      setFileDescription("");
      onClose();
    } catch (error) {
      showNotification(`${t("file.errorSaving")}: ${error.message}`, "error");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("file.fileName")}
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("file.fileDescription")}
              value={fileDescription}
              onChange={(e) => setFileDescription(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
            >
              {t("file.updateButton")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
